import { render, staticRenderFns } from "./VIPRefundHistory.vue?vue&type=template&id=400dd1b9&scoped=true&"
import script from "./VIPRefundHistory.vue?vue&type=script&lang=js&"
export * from "./VIPRefundHistory.vue?vue&type=script&lang=js&"
import style0 from "./VIPRefundHistory.vue?vue&type=style&index=0&id=400dd1b9&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400dd1b9",
  null
  
)

export default component.exports